import React, { useState } from "react";
import { Card } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { getDepartmentFiles } from "../../api/api";
import { useAppContext } from "../../AppContext";
import { useQuery } from "react-query";
import { LibrarySection, fetchLibrariesSectionsFiles } from "../../api/api";
import { string } from "yargs";

const LibrariesFilesOfDivision = (departmentid: any) => {
  const app = useAppContext();
  const user = app.user || { displayName: "", email: "" };

  const { i18n, t } = useTranslation();
  function getMainDomain(email?: any) {
    if (!email) return ""; // Return empty string if email is undefined
    const match = email.match(/@([^.]+)\./); // Match text between '@' and first '.'
    return match ? match[1].toLowerCase() : null;
  }

  //   const { isLoading, error, data } = useQuery<LibrarySection[]>(
  //     //["libraryData", i18n.language],
  //     ["librariesSectionsFiles", i18n.language],
  //     () =>
  //       fetchLibrariesSectionsFiles(
  //         i18n.language,
  //         departmentid?.departmentid,
  //         getMainDomain(user?.email ?? null)
  //       ),
  //     { keepPreviousData: true }
  //   );
  const { isLoading, error, data } = useQuery<LibrarySection[]>(
    ["librariesSectionsFiles", i18n.language, user.email], // Add user.email as a dependency
    () =>
      fetchLibrariesSectionsFiles(
        i18n.language,
        departmentid?.departmentid,
        getMainDomain(user?.email)
      ),
    {
      keepPreviousData: true,
      enabled: !!user.email, // Ensures query only runs when user.email is available
    }
  );

  if (isLoading) return;
  if (error) return;
  if (!data || data.length === 0) return;

  return (
    <>
      <Card className="mb-4">
        {/* <Card.Header>{t("departments")}</Card.Header> */}
        <Card.Header> {t("library_widget_department.header")} </Card.Header>
        <Card.Body>
          <div className="row">
            {data.map((department: any) => (
              <div key={department.id} className="col-md-6 col-lg-4 mb-4">
                <div className="card border-light shadow-sm">
                  <div
                    className="card-header  text-white text-center"
                    style={{ backgroundColor: "#1a3e6e" }}
                  >
                    <h6 className="m-0"> {department?.title} </h6>
                  </div>
                  <ul className="list-group list-group-flush">
                    {/* {JSON.stringify(department?.attributes?.libraries?.data)} -  */}
                    {department?.files.map((file: any) => (
                      // JSON.stringify(file)
                      <li
                        key={file?.id}
                        className="list-group-item d-flex justify-content-between align-items-center"
                      >
                        <a
                          href={
                            process.env.REACT_APP_CMS + file?.attributes?.url
                          }
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-dark fs-8"
                        >
                          {file?.attributes?.name}
                        </a>

                        <a
                          href={
                            process.env.REACT_APP_CMS + file?.attributes?.url
                          }
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-dark fs-8"
                        >
                          <span className="badge bg-secondary">📄</span>
                        </a>
                      </li>
                      
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>
        </Card.Body>
      </Card>
    </>
  );
};

export default LibrariesFilesOfDivision;
